export default __webpack_public_path__ + "static/media/buzzfeed.97c5e9ef.svg";